import { SearchIndividualResult } from "@/Common/Api/Individuals/Dto/SearchIndividualResult";
import { PatientHelper } from "@/Common/Helpers/PatientHelper";
import { Person } from "@/Common/Models/Person/Person";
import { PatientProfileMyleDto } from "@/Common/Models/Portal/Patient/SharedPatientMyleDto";
import * as ServerOperations from "@/Common/Operations/operations.server";
import { BaseAction } from "@/Common/Stores/Actions/BaseAction";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseServerOperationHandler } from "@/Common/Stores/Handlers/Server/BaseServerOperationHandler";
import { SidebarStore } from "@/Common/Stores/SidebarStore";

class SidebarResponseHandler extends BaseServerOperationHandler {
    constructor(action: BaseAction) {
        super(action);

        this.RegisterOperation(ServerOperations.Server.Myle_CreatePatient, this.createPatient);
        this.RegisterOperation(ServerOperations.Server.Myle_SearchIndividual, this.searchRelative);
        this.RegisterOperation(ServerOperations.Server.Portal_Proxy_SearchPatientProfiles, this.searchPortalClients);
        this.RegisterOperation(ServerOperations.Server.Myle_Questionnaire_GetQuestionnaireNoticeCounts, this.getNoticeCounts);
    }

    private searchRelative(response: ServerEvent, store: SidebarStore): void {
        if (response.Data.OrderedResponseId < store.currentSearchId)
            return;

        const collection: Person[] = response.Data.SearchIndividualResults
            .map((individual: SearchIndividualResult) => Person.FromSearchIndividualResult(individual));

        store.Model = store.Model.set("SearchResultsPatients", Immutable.List(collection));
    }

    private createPatient(response: ServerEvent): void {
        if (response.Errors && response.Errors.length > 0)
            sessionStore.showPopup(response.Errors);

        var contactId = response.Data["PatientContactId"];
        var pcmJs = PatientHelper.getDefaultPatientCreationModel();
        sidebarStore.Model = sidebarStore.Model.set("PatientCreationModel", Immutable.fromJS(pcmJs));
        sidebarStore.Model = sidebarStore.Model.set("IsCreateMode", false);

        patientStore.setActivePatientUI(contactId);
    }

    private searchPortalClients(response: ServerEvent, store: SidebarStore): void {
        var clients: PatientProfileMyleDto[] = response.Data.Clients;
        var searchResultsPersons = clients
            .map((p: PatientProfileMyleDto) => Person.FromPortalPatientProfile(p));

        store.Model = store.Model.set("SearchResultsPatients", Immutable.List(searchResultsPersons));
    }

    private getNoticeCounts(response: ServerEvent, store: SidebarStore): void {
        if (response.Errors && response.Errors.length > 0)
            sessionStore.showPopup(response.Errors);

        store.Model = store.Model.set("UnsubmittedQuestionnairesCount", response.Data.UnsubmittedCount)
            .set("PositiveQuestionnaireResultCount", response.Data.PositivesCount);
    }
}

export { SidebarResponseHandler };
